import {
  List,
  ListItem,
  Stack,
  Text,
  Heading,
  Input,
  Divider,
  IconButton,
} from '@chakra-ui/react'
import { AddIcon, SpinnerIcon, DeleteIcon } from '@chakra-ui/icons'
import CellLoading from 'src/components/CellLoading'
import { useState, useRef } from 'react'
import { useMutation, useQuery, gql } from '@apollo/client'
import { motion, LayoutGroup } from 'framer-motion'
const MotionList = motion(List)

export const QUERY = gql`
  query AdminListQuery {
    admins {
      id
      email
      super
    }
  }
`

const ADD_ADMIN = gql`
  mutation AddAdminMutation($email: String!) {
    addAdmin(email: $email) {
      id
      email
      super
    }
  }
`

const REMOVE_ADMIN = gql`
  mutation RemoveAdminMutation($email: String!) {
    removeAdmin(email: $email) {
      id
      email
      super
    }
  }
`

export const Loading = CellLoading

export const Empty = () => <div>Empty</div>

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ admins }) => {
  const [list, setList] = useState(admins)
  const [loading, setLoading] = useState('')
  const inputEl = useRef(null)
  const [addAdmin] = useMutation(ADD_ADMIN)
  const [removeAdmin] = useMutation(REMOVE_ADMIN)

  const handleRemove = async (email) => {
    setLoading(email)
    const ret = await removeAdmin({ variables: { email } })
    setList(ret.data.removeAdmin)
    setLoading('')
  }

  const handleAdd = async () => {
    const email = inputEl.current.value
    if (
      (email.endsWith('@beehively.com') || email.endsWith('@techabee.com')) &&
      email.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)
    ) {
      setLoading('add')
      const ret = await addAdmin({ variables: { email: email } })
      inputEl.current.value = ''
      setList(ret.data.addAdmin)
      setLoading('')
    } else {
      alert('email address should be beehively.com email')
    }
  }

  return (
    <Stack minW={700} spacing={5}>
      <Heading size="lg">Add Support Personnel</Heading>
      <Text fontSize="sm">
        Beehively people with following email can login into any school
      </Text>
      <Stack isInline>
        <Input
          ref={inputEl}
          placeholder="Enter any email address of a new admin"
        />
        <IconButton
          onClick={handleAdd}
          isDisabled={loading === 'add'}
          icon={loading === 'add' ? <SpinnerIcon /> : <AddIcon />}
        />
      </Stack>
      <Divider borderColor="red.100" />
      <LayoutGroup>
        <MotionList layout>
          {list.map((e) => (
            <ListItem
              key={e.id}
              as={InlineStack}
              borderRadius={9}
              _hover={{ bg: 'blue.100' }}
            >
              <Text fontSize="lg">{e.email}</Text>
              <IconButton
                onClick={() => handleRemove(e.email)}
                isDisabled={e.super}
                icon={loading === e.email ? <SpinnerIcon /> : <DeleteIcon />}
              />
            </ListItem>
          ))}
        </MotionList>
      </LayoutGroup>
    </Stack>
  )
}

export const InlineStack = (props) => (
  <Stack
    isInline
    justify="space-between"
    align="center"
    padding={2}
    {...props}
  />
)
